export const initialValues = {
  part_number: '',
  sell_price: 0,
  cost_price: 0,
  process: [],
};
